import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../service/login/login.service';
import { Router, ActivatedRoute } from "@angular/router";


@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css'],
})
export class ContactUsComponent implements OnInit {
  leftMenu1 = true;
  leftMenu2 = false;

  constructor(private router: Router, private service: LoginService,) { }

  ngOnInit() {
  }

  touch(num: number) {
    switch (num) {
      case 1:
        localStorage.setItem('type', "联系方式")
        this.router.navigate(["/contactUs/contactWays"])
        this.leftMenu1 = true
        this.leftMenu2 = false

        break
      case 2:
        localStorage.setItem('type', "人才招聘")
        this.router.navigate(["/contactUs/talentSeek"])
        this.leftMenu1 = false
        this.leftMenu2 = true

        break
    }

  }


}
